@if (visible) {
  <div
    class="spinner-overlay"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="spinner-overlay__loader" aria-hidden="true"></div>
    <span class="spinner-overlay__label">{{ label }}</span>
  </div>
}
